import type {RichTextField} from '@prismicio/client'
import {isFilled} from '@prismicio/client'
import {PrismicRichText} from '@prismicio/react'
import type {FC} from 'react'
import {memo} from 'react'

interface CountdownTitleProps {
  title: RichTextField
}

export const CountdownTitle: FC<CountdownTitleProps> = memo(({title}) => {
  if (!isFilled.richText(title)) {
    return null
  }

  return (
    <div className="text-center">
      <PrismicRichText
        field={title}
        components={{
          heading3: ({children}) => (
            <h3 className="relative text-[20px] font-medium leading-7 tracking-[0.2px] md:text-[32px] md:leading-10 md:tracking-[0.32px]">
              {children}
            </h3>
          ),
          strong: ({children}) => <strong className="font-medium opacity-70">{children}</strong>,
        }}
      />
    </div>
  )
})

CountdownTitle.displayName = 'CountdownTitle'
